import React, {Component} from 'react';
import {Router} from 'react-router';
import NProgress from 'nprogress';

import CONFIG from './config';
import Routes from './Routes';
import {NavigationActions} from './services/Navigation';
import Navigation from './Navigation';
import Log from "./Log";
import AppServices from './AppServices';
import RestApi from './services/RestApi';

import {NotAuthorizedException, NotFoundException} from "./Exceptions";
import ErrorNotFound from "./pages/ErrorNotFound";
import ErrorNotAuthorized from "./pages/ErrorNotAuthorized";
import ErrorApplication from "./pages/ErrorApplication";
import {SessionStore} from "./services/Session";

class App extends Component {
    constructor(props) {
        super(props);
        this.history = Navigation.getHistory();
        this.updateLocation = this.updateLocation.bind(this);
        this.configure();
    }

    configure() {
        // See: https://github.com/rstacruz/nprogress
        NProgress.configure({ showSpinner: false, speed: 100, trickleSpeed: 100, minimum: 0.4 });
        AppServices.setup({
            restApi: new RestApi(CONFIG.apiUrl, function () {
                return SessionStore.getToken();
            })
        });
        this.state = {
            hasError: false
        }
        // Initialise navigation store with current location
        this.updateLocation(this.history.getCurrentLocation());
    }

    updateLocation(location) {
        NavigationActions.updateLocation.defer(location);
        if (this.state.hasError) this.setState({hasError: false});
    }

    componentDidMount() {
        // Set up automatic location storing:
        this.historyUnlisten = this.history.listen((location) => this.updateLocation(location));
    }

    componentDidCatch(error, info) {
        Log.exception(error);
        Log.debug(info);
        // Display fallback UI
        this.setState({ hasError: true, error: error, errorInfo: info });
    }

    onLog(state) {
        this.setState({log: state});
    }

    componentWillUnmount() {
        if (this.historyUnlisten) {
            this.historyUnlisten();
            this.historyUnlisten = null;
        }
    }

    renderException(error, errorInfo) {
        if (error instanceof NotFoundException) return (<ErrorNotFound error={error} errorInfo={errorInfo}/>);
        if (error instanceof NotAuthorizedException) return (<ErrorNotAuthorized error={error} errorInfo={errorInfo}/>);
        return (<ErrorApplication error={error} errorInfo={errorInfo}/>);
    }

    render() {
        if (this.state.hasError) return this.renderException(this.state.error, this.state.errorInfo);
        return (<Router history={this.history} routes={Routes} />);
    }
}

export default App;
